import cloneDeep from 'clone-deep'
import deepEqual from 'deep-equal'
import { Inject, Injectable } from '@angular/core'
import { BootstrapData, Parameters, ParametersUpdate } from 'elements-sdk'
import { APIService, BOOTSTRAP_DATA } from 'api/module'

@Injectable({ providedIn: 'root' })
export class ParametersService {
  readonly values: Parameters
  private lastValues: Parameters

  constructor (
    private api: APIService,
    @Inject(BOOTSTRAP_DATA) bootstrapData: BootstrapData,
  ) {
    this.lastValues = bootstrapData.parameterValues
    this.values = cloneDeep(this.lastValues)

    if (bootstrapData.publicParameters.brandingCss) {
      const style = document.createElement('style')
      style.innerHTML = bootstrapData.publicParameters.brandingCss
      document.body.appendChild(style)
    }
  }

  async commit (): Promise<void> {
    const model = await this.api.main.getParameters({})
    for (const k of Object.keys(this.lastValues)) {
      if (!deepEqual(this.values[k], this.lastValues[k])) {
        model[k] = this.values[k]
      }
    }
    await this.api.main.updateParameters({
      parametersUpdate: model as ParametersUpdate,
    })
    Object.assign(this.values, cloneDeep(model))
    this.lastValues = cloneDeep(model)
  }
}
